import React, { lazy, Suspense } from 'react';
import {connect} from "react-redux";
import {ErrorBoundary} from "react-error-boundary";
import {CONFIG} from "../../../app/config";
import {logError} from "../../core";

import Header from '../../../app/components/component.header';
import Footer from '../../../app/components/component.footer';
import Loader from "../../../app/components/component.loader";

import ComponentError from "../../../app/components/component.error";

const AdminBar = lazy(() => import("./component.admin-bar"));
const DevPanel = lazy(() => import("../dev/component.dev-panel"));
const Preview = lazy(() => import("./component.preview"));

const ComponentCookie = lazy(() => import("./component.cookie"));

const Page = lazy(() => import("./component.page"));

const isProduction = process.env.NODE_ENV === 'production';

const Main = (props) => {
    return <>
        <ErrorBoundary FallbackComponent={(error, reset) => { return <ComponentError error={error} reset={reset} />}} onError={(error) =>  { logError('page_render', error.message) }}>
            <div className="site-container">
                <Header />
                <main id="content">
                    {props.pageState.page &&
                        <Suspense fallback={<Loader/>}>
                            <Page />
                        </Suspense>}
                    {!props.pageState.page && <Loader/>}
                </main>
            </div>
            <Footer />
        </ErrorBoundary>
        {props.authState.data &&
        <Suspense fallback={<span>Loading...</span>}>
            <AdminBar />
            <Preview />
        </Suspense>}
        {!isProduction &&
        <Suspense fallback={<span>Loading...</span>}>
            <DevPanel />
        </Suspense>}
        {CONFIG.components?.cookie_bar &&
        <Suspense fallback={<span>Loading...</span>}>
            <ComponentCookie {...CONFIG.components.cookie_bar} />
        </Suspense>}
    </>
};

export default connect(state => {
    return {
        authState: state.authState,
        pageState: state.pageState
    }
})(Main);
